import { createFileRoute, useParams } from '@tanstack/react-router'
import PageLogout from '@/pages/account/logout'

export const Route = createFileRoute('/app/account/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = useParams({ strict: false })
  const appDest = (params as any).appDest || ''

  return <PageLogout appDest={appDest} />
}
